import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Typography, Pagination } from '@mui/material';
import { useIntl } from 'react-intl';

export const TrainingSessionMobileBlock = ({ trainingsData, handleRowClick }) => {
  const { trainings } = trainingsData;
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  const intl = useIntl();

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedTrainings = trainings.slice(startIndex, endIndex);

  return (
    <Box display="flex" flexDirection="column" gap={2} padding={2}>
      {displayedTrainings.map((training) => (
        <Card
          key={training.id}
          onClick={() => handleRowClick(training)}
          sx={{
            cursor: 'pointer',
            boxShadow: 2,
            '&:hover': { boxShadow: 4 },
          }}
        >
          <CardContent>
            <Typography variant="h6" gutterBottom>
              {intl.formatMessage({
                id: 'training.form.label.trainingName',
                defaultMessage: 'Training Name',
              })}: {training.trainingName}
            </Typography>
            <Typography variant="body2">
              {intl.formatMessage({
                id: 'training.form.label.trainingDate',
                defaultMessage: 'Training Date',
              })}: {new Date(training.trainingDate).toLocaleString()}
            </Typography>
            <Typography variant="body2">
              {intl.formatMessage({
                id: 'training.form.label.creator',
                defaultMessage: 'Creator',
              })}: {training.creator}
            </Typography>
            <Typography variant="body2">
              {intl.formatMessage({
                id: 'training.form.label.location',
                defaultMessage: 'Location',
              })}: {training.location}
            </Typography>
          </CardContent>
        </Card>
      ))}
      {/* Pagination */}
      <Pagination
        count={Math.ceil(trainings.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
};

TrainingSessionMobileBlock.propTypes = {
  trainingsData: PropTypes.shape({
    trainings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        trainingName: PropTypes.string.isRequired,
        trainingDate: PropTypes.string.isRequired,
        creator: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  handleRowClick: PropTypes.func.isRequired,
};
